import React from 'react';

export default props => (
  <div className="table-footer clear-fix" style={props.style}>
    {props.leftSide && <div className="pull-left table-footer-left">{props.leftSide}</div>}
    {props.rightSide && <div className="pull-right table-footer-right">{props.rightSide}</div>}
    {props.centerSide && <div className="table-footer-center">{props.centerSide}</div>}
  </div>
);
